module.exports = __webpack_public_path__ + "static/02-prototyping-small-366cd80086b4c32ba609be16c8dc71f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/homepage/02-prototyping-small.jpg
// module id = 2639
// module chunks = 35783957827783